import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './crowdfunding_nonprofit.less'
import { getI18nBase } from 'client/i18n'
import { BodyText, HeadingText, Avatar } from '@paypalcorp/pp-react'
import { trackEventNameClick } from 'lib/fpti_analytics'
import Typeahead from 'components/common/type_ahead_search'
import HorizontalScroller from 'components/horizontal_scroller'
import { Message } from '@paypalcorp/worldready-react'
import { validateImagePath } from 'shared/campaign_url'

export const I18N_CONTEXT =
  'components/pages/crowdfunding/crowdfunding_nonprofit'
export const I18N_CONTEXT_TITLE = 'components/pages/crowdfunding/pool_nonprofit'

const i18nBase = getI18nBase(I18N_CONTEXT)
const i18nBaseTitle = getI18nBase(I18N_CONTEXT_TITLE)

class NonProfitPage extends React.Component {
  static propTypes = {
    featuredCharities: PropTypes.arrays,
    selectCharity: PropTypes.func,
    getCharities: PropTypes.func.isRequired,
    isMobile: PropTypes.bool,
  }

  getOptions = (options, userText) => {
    if (!userText) {
      return []
    }
    return this.props
      .getCharities({
        search_all: userText,
        page: 1,
        page_size: 30,
      })
      .then(this.getResponse)
  }

  getResponse = resp => {
    return resp || []
  }

  getSelectedItem = item => {
    trackEventNameClick({
      event_name: 'dw_giving_browse_fundraiser_charity_selection_pressed',
      charity_name: item.name,
      npid: item.nonprofit_id,
    })
    this.props.selectCharity(item)
  }

  setItemDecoration(item) {
    const logoURL = validateImagePath(item.logo_url)
    return (
      <React.Fragment>
        {logoURL ? (
          <div
            styleName="thumbnail"
            style={{
              background: `url(${
                item.logo_url
              }) center center / contain no-repeat`,
            }}
          />
        ) : (
          <Avatar styleName="thumbnail" generic="causes" size="sm" />
        )}
        <p styleName="item-text">
          {item.name}
          <div>{`${item.address.city}, ${item.address.country_code}`}</div>
        </p>
      </React.Fragment>
    )
  }

  handleCardOnClick = item => {
    trackEventNameClick({
      event_name: 'dw_giving_find_fundraiser_charity_recommendation_pressed',
      charity_name: item.name,
      npid: item.nonprofit_id,
    })

    this.props.selectCharity(item)
  }

  render() {
    const { featuredCharities, isMobile } = this.props

    return (
      <div>
        <HeadingText size="sm" styleName="title">
          {i18nBaseTitle('title')}
        </HeadingText>
        <div
          styleName="textbox-wrapper"
          onClick={() =>
            trackEventNameClick({
              event_name: 'dw_giving_find_fundraiser_charity_search_pressed',
            })
          }
        >
          <Typeahead
            name="charitySearch"
            getOptions={this.getOptions}
            getSelectedItem={this.getSelectedItem}
            setItemDecoration={cssModules(this.setItemDecoration, styles)}
            delay={1000}
            datasource="name"
            data-nemo="charity_search"
            label={i18nBase('search_placeholder')}
          />
        </div>
        {featuredCharities.length > 0 && (
          <>
            <BodyText size="sm" styleName="legend">
              <Message id="components.pages.crowdfunding.crowdfunding_nonprofit.charity_header" />
            </BodyText>
            <HorizontalScroller
              isMobile={isMobile}
              items={featuredCharities}
              dataTestId="np-featured-charities"
              onClick={this.handleCardOnClick}
            />
          </>
        )}
      </div>
    )
  }
}
export default cssModules(NonProfitPage, styles)
